export const iconFontAwesomeHalloweenBookSkull = (
	<i className="fa-solid fa-book-skull"></i>
);
